<template>
    <el-menu background-color="#545c64" text-color="#fff" active-text-color="#ffd04b"
        mode="horizontal"
        :default-active="actId"
        :collapse="isCollapse"
        :collapse-transition="false"
        @select="selectMenu" router>
        <template v-for="menu in menuData">
            <el-submenu :index="(''+menu.fMenu.id)" :key="menu.fMenu.id" v-if="menu.fMenu.loner==0">
                <template slot="title">
                    <!-- <i :class="(menu.fMenu.css==''?'el-icon-s-operation':menu.fMenu.css)"></i> -->
                    <span>{{menu.fMenu.name}}</span>
                </template>
                <el-menu-item v-for="smenu in menu.sMenuList" :key="smenu.id" style="padding-left: 30px" :index="(''+smenu.id)" :route="smenu.linkurl">{{smenu.name}}</el-menu-item>
            </el-submenu>
            <el-menu-item :index="(''+menu.sMenuList[0].id)" :key="menu.sMenuList[0].id" :route="menu.sMenuList[0].linkurl"  v-if="menu.fMenu.loner==1 && menu.fMenu.id!=1910">{{menu.sMenuList[0].name}}</el-menu-item>
        </template>
    </el-menu>
</template>

<script>
export default {
    props: {
        actId: {
            type: String,
            default(){
                return "0"
            }
        },
        menuData: {
            type: Array,
            default() {
                return [];
            },
        },
        isCollapse: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    methods: {
        selectMenu(key, keyPath) {
            let k = keyPath[0]
            if(keyPath.length==1){
                for (const index in this.menuData) {
                    const sMenuList = this.menuData[index].sMenuList
                    for (const sIndex in sMenuList) {
                        if((sMenuList[sIndex].id+'') == k){
                            k = this.menuData[index].fMenu.id
                            break
                        }
                    }
                    if(keyPath != (k+'')){
                        break
                    }
                }
            }
            this.$emit("selectMenu", { sMenuIndex: key, fMenuIndex: k, menu: 1});
        },
    },
};
</script>